import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useEffect } from 'react';
import { useDragDropManager } from './2c2a08c7de500853fb7e7fc6c23b7488305aacbb55475e14a20fb57649979a77.cfe-internal.js';
import { useCollector } from './47acb958c05758e30a34a4ecca392fda35867094ff2b705c30f618cee450a279.cfe-internal.js';

/**
 * useDragLayer Hook
 * @param collector The property collector
 */
function useDragLayer(collect) {
  var dragDropManager = useDragDropManager();
  var monitor = dragDropManager.getMonitor();
  var _useCollector = useCollector(monitor, collect),
    _useCollector2 = _slicedToArray(_useCollector, 2),
    collected = _useCollector2[0],
    updateCollected = _useCollector2[1];
  useEffect(function () {
    return monitor.subscribeToOffsetChange(updateCollected);
  });
  useEffect(function () {
    return monitor.subscribeToStateChange(updateCollected);
  });
  return collected;
}

export { useDragLayer };
